import { Link } from 'src/components/navigation/link.component'
import { CurecallButton, CurecallModalContainer, ECurecallButtonAppearance } from '@honestica/curecall-ui'
import { useParams } from 'react-router-dom'
import { useTestAccountPool } from 'src/providers/test-account-pool.provider'
import { getPhone } from 'src/utils/phone.util'
import { getFullName } from 'src/utils/string-formatter.util'
import { useTranslation } from 'react-i18next'

interface TestAccountPoolModalProps {
  onClose: () => void
  isOpen: boolean
}

const TestAccountPoolModal = ({ onClose, isOpen }: TestAccountPoolModalProps) => {
  const { projectId } = useParams()
  const { testAccountsPool, handleChangeTestAccountsPool } = useTestAccountPool()
  const { t } = useTranslation()

  const handleDelete = (id: number) => {
    handleChangeTestAccountsPool(testAccountsPool.filter((item) => item.id !== id))
  }

  const clearLocalStorage = () => {
    handleChangeTestAccountsPool([])
  }

  const modaleTitle = () => {
    return (
      <div className="c-flex c-justify-between c-items-center">
        {t('components.demo-group.demo-group-management')}
        <CurecallButton appearance={ECurecallButtonAppearance.ALERT} onClick={clearLocalStorage}>
          {t('components.demo-group.reinitialize-demo-group')}
        </CurecallButton>
      </div>
    )
  }

  return (
    <CurecallModalContainer
      closeModalAriaLabel={t('common.actions.close')}
      title={modaleTitle()}
      isOpen={isOpen}
      toggle={onClose}
    >
      <p className="c-mt-2 c-text-sm c-text-gray-700">
        {t('components.demo-group.patient-list-in-demo-group')}
      </p>
      <div className="c-mt-8 c-flex c-flex-col">
        <div className="c--my-2 c--mx-4 c-overflow-x-auto sm:c--mx-6 lg:c--mx-8">
          <div className="c-inline-block c-min-w-full c-py-2 c-align-middle md:c-px-6 lg:c-px-8">
            <div className="c-overflow-hidden c-shadow c-ring-1 c-ring-black c-ring-opacity-5 md:c-rounded-lg">
              <table className="c-min-w-full c-divide-y c-divide-gray-300">
                <thead className="c-bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="c-py-3.5 c-pl-4 c-pr-3 c-text-left c-text-sm c-font-semibold c-text-gray-900 sm:c-pl-6"
                    >
                      ID
                    </th>
                    <th
                      scope="col"
                      className="c-px-3 c-py-3.5 c-text-left c-text-sm c-font-semibold c-text-gray-900"
                    >
                      {t('components.demo-group.patient-test')}
                    </th>
                    <th
                      scope="col"
                      className="c-px-3 c-py-3.5 c-text-left c-text-sm c-font-semibold c-text-gray-900"
                    >
                      {t('components.demo-group.phone')}
                    </th>
                    <th scope="col" className="c-relative c-py-3.5 c-pl-3 c-pr-4 sm:c-pr-6">
                      <span className="c-sr-only">{t('components.demo-group.action')}</span>
                    </th>
                  </tr>
                </thead>
                <tbody className="c-divide-y c-divide-gray-200 c-bg-white">
                  {testAccountsPool?.map((patient, i) => (
                    <tr key={i}>
                      <td className="c-whitespace-nowrap c-py-4 c-pl-4 c-pr-3 c-text-sm c-font-medium c-text-gray-900 sm:c-pl-6">
                        {patient.id}
                      </td>
                      <td className="c-whitespace-nowrap c-px-3 c-py-4 c-text-sm c-text-gray-500">
                        {getFullName(patient)}
                      </td>
                      <td className="c-whitespace-nowrap c-py-4 c-pl-4 c-pr-3 c-text-sm c-font-medium c-text-gray-900 sm:c-pl-6">
                        {getPhone(t, patient.phone)}
                      </td>
                      <td className="c-relative c-space-x-3 c-whitespace-nowrap c-py-4 c-pl-3 c-pr-4 c-text-right c-text-sm c-font-medium sm:c-pr-6">
                        <Link
                          to={`/${projectId}/medical/patients/${patient.id}`}
                          className="c-text-indigo-600 hover:c-text-indigo-900"
                        >
                          {t('components.demo-group.see')}
                        </Link>
                        <span
                          onClick={() => handleDelete(patient.id)}
                          className="c-text-indigo-600 hover:c-text-indigo-900 c-cursor-pointer"
                        >
                          {t('components.demo-group.delete')}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </CurecallModalContainer>
  )
}

export default TestAccountPoolModal
